<template>
  <div>
    <modal
      :adaptive="true"
      :scrollable="true"
      name="hello-world"
      height="700"
      width="800"
    >
      <div class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-1">
            <i
              class="fa fa-folder"
              style="font-size: 47px !important; color: grey"
            ></i>
          </div>
          <div class="col-md-9">
            <p class="text-primary" style="margin-bottom: -4px;">
              <strong >DETALLE DE LA</strong>
              <strong v-if="formato == 1">AUTORIZACIÓN</strong>
              <strong v-if="formato == 0">ORDEN MÉDICA</strong>
              <strong v-if="formato == 2">SERVICIO PARTICULAR</strong>
              <strong v-if="formato == 3">CONVENIO</strong>
            </p>
            <p style="color:grey;">{{ servicioSeleccionado }}</p>
          </div>
          <div class="col-md-2">
            <button
              @click="cerrarModal()"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
      <div class="modal-body" style="min-height: 80%; height: 80%; max-height: 80%; overflow-y: scroll;">
        <div>
          
          <div class="">
            <div class="row">
              <div class="col-md-12">
                <p class="title-card-detail">Nombre completo del paciente</p>
                <strong>{{ nombreSeleccionado }}</strong>
              </div>
              <div class="col-md-6">
                <br>
                <p class="title-card-detail"> <i class="fa fa-calendar"></i> Fecha de expedición </p>
                <strong>{{ fechaSeleccionada | date }}</strong>
              </div>
              <div class="col-md-6">
                <br>
                <p class="title-card-detail"> <i class="fa fa-calendar"></i> Fecha de vencimiento </p>
                <strong>{{ fechaVencimientoSeleccionada | date }}</strong>
              </div>
              <div class="col-md-6" v-if="tipoOrden == 'particular' || tipoOrden == 'adm'">
                <br />
                <p class="title-card-detail"> <i class="fa fa-pencil"></i> Observaciones </p>
                
                <strong>{{ observaciones }}</strong>
              </div>
              <div class="col-md-6" v-if="tipoOrden == 'particular'">
                <br />
                <p class="title-card-detail"> <i class="fa fa-user"></i> Nombre del cliente </p>
                
                <strong>{{ nombre_cliente }}</strong>
              </div>
              <div class="col-md-6" v-if="tipoOrden === 'adm'">
                <br />
                <p class="title-card-detail"> <i class="fa fa-pencil"></i> Dato </p>
                <strong>
                  <i class="fa fa-info"></i>
                  Esta autorización fue ingresada como "codigo 90" por:
                  {{ usuarioOrden }}
                </strong>
              </div>
             
            </div>
            <div class="row" v-if="formato == 0">
              <div class="col-md-12">
                
                <h4 class="text-primary">Servicios ordenados</h4>
                  <el-table
                    v-if="arrayServiciosOrden != []"
                    :data="arrayServiciosOrden"
                    border
                    class="table-responsive"
                  >
                    <el-table-column type="index"></el-table-column>
                    <el-table-column
                      prop="EspNom"
                      label="Servicio"
                    ></el-table-column>
                    <el-table-column
                      prop="OrdEspSes"
                      label="Cantidad"
                      width="130"
                    ></el-table-column>
                  </el-table>
                  <h1 v-else>Cargado datos...</h1>
                
              </div>
              <div class="col-md-12">
                <h4 class="text-primary">Autorizaciones de la orden</h4>
                <el-table
                  :data="arrayAutorizaciones"
                  border
                  style="width: 100%"
                  class="table-responsive"
                >
                  <el-table-column type="index"></el-table-column>
                  <el-table-column
                    prop="OrdCod"
                    label="Servicio"
                  ></el-table-column>
                  <el-table-column
                    prop="OrdFec"
                    label="Fecha"
                  ></el-table-column>
                  <el-table-column
                    prop="OrdVen"
                    label="Fecha de vencimiento"
                  ></el-table-column>
                  <el-table-column label width="50">
                    <template slot-scope="props">
                      <a
                        class="btn btn-simple btn-success btn-xs btn-icon like"
                        @click="verServiciosAutorizacion(props.row)"
                      >
                        <i class="fa fa-eye"></i>
                      </a>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <br />
            </div>
            <div class="row" v-if="arrayServiciosAutorizacion != ''">
              <div class="col-md-12">
               
                  <br />
                  <h4 class="text-primary">Servicios autorizados</h4>
                  <el-table
                    :data="arrayServiciosAutorizacion"
                    border
                    style="width: 100%"
                    class="table-responsive table-striped"
                  >
                    <el-table-column type="index"></el-table-column>
                    <el-table-column
                      prop="EspNom"
                      label="Servicio"
                    ></el-table-column>
                    <el-table-column
                      prop="OrdEspSes"
                      label="Cantidad autorizada"
                    ></el-table-column>
                  </el-table>
               
              </div>
            </div>
          </div>
          <hr>
          
        
        </div>
        
      </div>
      <div class="modal-footer">
          <center>
            <button
             style="border-radius: 5px"
              type="button"
              class="btn btn-success btn-fill"
              @click="cerrarModal()"
            >
              Cerrar ventana
            </button>
          </center>
        </div>
    </modal>
    <div class="col-md-12">
      <div class="col-md-6">
        <input
          type="text"
          class="form-control"
          v-model="searchQuery"
          placeholder="Buscar..."
        />
      </div>
      <button
        class="btn btn-fill btn-danger"
        style="border-radius: 5px"
        @click="ordenes()"
      >
        <i class="fa fa-refresh"></i> Recargar datos
      </button>
      <br />
      <br />
      <!-- <div class="col-md-6" v-for="orden in buscarOrdenes" :key="orden.OrdCod">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-1">
                <i class="fa fa-file" style="color: grey; font-size: 37px"></i>
              </div>
              <div class="col-md-8">
                <h5 class="card-title">
                  <strong>{{ orden.OrdCod }}</strong>
                </h5>
                <p class="category" v-if="orden.OrdFor == 0">ORDEN MÉDICA</p>
                <p class="category" v-if="orden.OrdFor == 1">AUTORIZACIÓN</p>
                <p class="category" v-if="orden.OrdFor == 2">
                  SERVICIO PARTICULAR
                </p>
                <p class="category" v-if="orden.OrdFor == 3">CONVENIO</p>
              </div>
            </div>
          </div>
          <hr style="margin-left:15px; margin-right:15px;">
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <p>
                  Paciente:
                  <strong>{{ orden.PacApe1 }} {{ orden.PacNom1 }}</strong>
                </p>
                <p v-if="orden.OrdFor == 1 || orden.OrdFor == 0">
                  Entidad: <strong>{{ orden.EpsNom }}</strong>
                </p>
                <p v-if="orden.OrdFor == 2 || orden.OrdFor == 3">
                  Cliente: <strong>{{ orden.nombre_cliente }}</strong>
                </p>
                <p>
                  Fecha de expedición: <strong>{{ orden.OrdFec }}</strong>
                </p>
                <p>
                  Fecha de vencimiento: <strong>{{ orden.OrdVen }}</strong>
                </p>
              </div>
              <div style="margin: 8px">
                <button
                  class="btn btn-success btn-sm"
                  style="border-radius: 5px"
                  @click="abrirModal(orden)"
                >
                  <i class="fa fa-plus"></i> Ver más...
                </button>
              </div>
            </div>
            <br />
          </div>
          <br />
        </div>
        <br />
      </div> -->
      <div class="card-content ">
        <div class="col-sm-6">
          <label for>Cantidad de registros:</label>
          <br />
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page"
          >
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
         
        </div>
        
       
        <br>
        <div class="col-md-12">
         
          <el-table
            class="table-striped table-responsive"
            :data="queriedData"
            style="margin-top: 20px; width: 100%"
            max-height="500"
            border
           
          >
          <el-table-column  min-width="350" label="Paciente">
              <template slot-scope="props">
                <p>{{ props.row.PacApe1 }} {{ props.row.PacNom1 }}</p>
              </template>
            </el-table-column>
            <el-table-column  min-width="160" label="Tipo">
              <template slot-scope="props">
                <p v-if="props.row.OrdFor == 0">ORDEN MÉDICA</p>
                <p v-if="props.row.OrdFor == 1">AUTORIZACIÓN</p>
              </template>
            </el-table-column>
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
            <el-table-column min-width="220" label="Fecha de expedición">
              <template slot-scope="props">
              <p> {{ props.row.OrdFec | date }} </p>
            </template>
            </el-table-column>
            <el-table-column min-width="220"  label="Fecha de vencimiento">
              <template slot-scope="props">
              <p> {{ props.row.OrdVen | date }} </p>
            </template>
            </el-table-column>
            <el-table-column min-width="220"  label="Dias para vencimiento">
              <template slot-scope="props">
              <p> {{ props.row.OrdVen | diasFaltantes }} dia(s)</p>
            </template>
            </el-table-column>
            <el-table-column min-width="130" fixed="right">
              <template slot-scope="props">
                <button
                  class="btn btn-success btn-sm"
                  style="border-radius: 5px"
                  @click="abrirModal(props.row)"
                >
                  <i class="fa fa-plus"></i> Ver más...
                </button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <br />
          <p class="category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          ></p-pagination>
        </div>
      </div>
      <div>
    </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Vuetify from "vuetify";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import axios from "axios";
Vue.use(Vuetify);
export default {
  computed: {
    pagedData() {
      return this.arrayOrdenes.slice(this.from, this.to);
    },
    /*
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.arrayOrdenes.length;
        return this.pagedData;
      }
      let result = this.arrayOrdenes.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.arrayOrdenes.length;
      return this.arrayOrdenes.length;
    },
  },
  components: {
    PPagination
  },
  data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      propsToSearch: [
        "PacNom1",
        "PacApe1",
        "OrdCod"
      ],
      tableColumns: [
        {
          prop: "OrdCod", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
          label: "Codigo", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
          minWidth: 250, //ANCHO DE LA COLUMNA
        },
        {
          prop: "EpsNom",
          label: "Entidad",
          minWidth: 250,
        }
      ],
      searchQuery: "",
      modalDetalles: 0,
      arrayOrdenes: [],
      tipoOrden: "",
      ip: "https://avanti-erp.com/",
      servicioSeleccionado: "",
      nombreSeleccionado: "",
      fechaSeleccionada: "",
      fechaVencimientoSeleccionada: "",
      formato: "",
      arrayServiciosOrden: [],
      arrayAutorizaciones: [],
      arrayServiciosAutorizacion: [],
      buscar: "",
      fechaActual: "",
      cancelar: false,
      usuarioOrden: "",
      ordide: 0,
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      observaciones: "",
      nombre_cliente: "",
    };
  },
  methods: {
    ordenes() {
      this.$modal.show("carga");
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };


      let rol = localStorage.getItem('rol');
      let sedeBuscar = 'todas';
      if( rol > 1 ){
        sedeBuscar = localStorage.getItem('sede');
      }
      let url = this.ip + "api/allOrdenes/" + this.fechaActual + "/" + sedeBuscar;
      axios
        .get(url, config)
        .then((response) => {
          this.arrayOrdenes = response.data.data;
          this.$modal.hide("carga");
        })
        .catch((error) => {
          console.log(error);
          this.$modal.hide("carga"); 
        });
    },
    verServiciosOrden(codigo) {
      this.$modal.show("carga");
      this.arrayServiciosOrden = [];
      var token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var url = this.ip + "api/verServiciosOrden/" + codigo;
      axios
        .get(url, config)
        .then((response) => {
          this.arrayServiciosOrden = response.data.data;
          this.$modal.hide("carga");
        })
        .catch((error) => {
          console.log(error);
          this.$modal.hide("carga");
        });
    },
    verServiciosAutorizacionUnica(codigo) {
      this.$modal.show("carga");
      this.cancelar = false;
      this.arrayServiciosAutorizacion = [];
      var token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var url = this.ip + "api/verServiciosOrden/" + codigo;
      axios
        .get(url, config)
        .then((response) => {
          this.arrayServiciosAutorizacion = response.data.data;
          for (var i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].sesiones_pro != 0) {
              this.cancelar = false;
              break;
            } else {
              this.cancelar = true;
            }
            // return 0;
            console.log(this.cancelar);
            this.$modal.hide("carga");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$modal.hide("carga");
        });
    },
    verAutorizaciones(codigo) {
      this.$modal.show("carga");
      var token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var url = this.ip + "api/verAutorizaciones/" + codigo;
      axios
        .get(url, config)
        .then((response) => {
          this.arrayAutorizaciones = response.data.data;
          this.$modal.hide("carga");
        })
        .catch((error) => {
          console.log(error);
          this.$modal.hide("carga");
        });
    },
    verServiciosAutorizacion(autorizacion) {
      this.$modal.show("carga");
      this.arrayServiciosAutorizacion = [];
      var token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var url = this.ip + "api/verServiciosOrden/" + autorizacion.OrdIde;
      axios
        .get(url, config)
        .then((response) => {
          this.arrayServiciosAutorizacion = response.data.data;
          this.$modal.hide("carga");
        })
        .catch((error) => {
          console.log(error);
          this.$modal.hide("carga");
        });
    },
    abrirModal(orden) {
      this.$modal.show("hello-world");
      this.modalDetalles = 1;
      this.servicioSeleccionado = orden.OrdCod;
      this.nombreSeleccionado = orden.PacApe1 + " " + orden.PacNom1;
      this.fechaSeleccionada = orden.OrdFec;
      this.tipoOrden = orden.TipSer;
      this.fechaVencimientoSeleccionada = orden.OrdVen;
      this.formato = orden.OrdFor;
      this.ordide = orden.OrdIde;
      this.usuarioOrden = orden.UsuAdm;
      this.observaciones = orden.observaciones;
      this.nombre_cliente = orden.nombre_cliente;

      console.log(orden);
      setTimeout(() => {
        if (orden.OrdFor == 0) {
          this.verServiciosOrden(orden.OrdIde);
          this.verAutorizaciones(orden.OrdCod);
        } else {
          this.verServiciosAutorizacionUnica(orden.OrdIde);
        }
      }, 1000);
    },
    cancelarOrden() {
      this.$modal.show("carga");
      var token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const BASE_URL = `${this.ip}api/cancelarOrden/${this.ordide}`;
      axios
        .put(BASE_URL)
        .then((res) => {
          this.$modal.hide("carga");
          if (res.data.status == true) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<span>!<br> Autorización desactivada con éxito!<br>.</span>`,
              },
              icon: "ti-info",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: this.type[color],
            });
            this.$modal.hide("hello-world");
            this.ordenes();
          } else {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<span>!<br>Ocurrió un error, intentelo de nuevo!<br>.</span>`,
              },
              icon: "ti-info",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: this.type[color],
            });
          }
        })
        .catch((error) => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `<span>!<br>Ocurrió un error en el servidor, intentelo de nuevo!<br>.</span>`,
            },
            icon: "ti-info",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: this.type[color],
          });
          this.$modal.hide("carga");
          console.log(error);
        });
    },
    cerrarModal() {
      this.$modal.hide("hello-world");
      this.modalDetalles = 0;
      this.servicioSeleccionado = "";
      this.nombreSeleccionado = "";
      this.fechaSeleccionada = "";
      this.fechaVencimientoSeleccionada = "";
      this.formato = "";
      this.arrayServiciosOrden = [];
      this.arrayAutorizaciones = [];
      this.arrayServiciosAutorizacion = [];
      this.arrayServiciosOrden = [];
    },
    calcular() {
      var fechaini = new Date("2020-02-21");
      var fechafin = new Date("2020-02-22");
      var diasdif = fechafin.getTime() - fechaini.getTime();
      var contdias = Math.round(diasdif / (1000 * 60 * 60 * 24));
      alert(contdias);
    },
    calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        // this.fechaIngreso = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        // this.fechaIngreso = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
  },
  // computed: {
  //   buscarOrdenes: function () {
  //     return this.arrayOrdenes.filter(
  //       (orden) =>
  //         orden["EpsNom"].includes(this.buscar.toLocaleUpperCase()) ||
  //         orden["OrdCod"].includes(this.buscar.toLocaleUpperCase()) ||
  //         orden["PacNom1"].includes(this.buscar.toLocaleUpperCase()) ||
  //         orden["PacApe1"].includes(this.buscar.toLocaleUpperCase())
  //     );
  //   },
  // },
  mounted() {
    this.calcularFechaActual();
    setTimeout(() => {
      this.ordenes();
    }, 2000);
  },
};
</script>
<style scoped>
.card-orden {
  max-height: 300px !important;
  /* height: 290px !important; */
  margin-bottom: 1% !important;
}

.texto-pequeno {
  font-size: 12px;
  color: darkgray;
  padding: 0px !important;
  margin: 0px !important;
}
small {
  color: grey;
  font-size: 12px;
  /* margin-top:-3px; */
}

.title-card-detail {
  color:grey;
  margin-bottom: -3px;
}


.card-header {
    padding-bottom: 10px !important;
    background-color: #f3f2ee;
    border-radius: 15px !important;
}

.card {
    box-shadow: 0 0 0 0;
    border-radius: 15px;
    padding: 2%;
}

.card-chart {
    box-shadow: 0 0 0 0;
    border-radius: 15px;
    /* padding: 4%; */
    margin: 2px;
    background-color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Admisiones/ordenes/ordenes.vue